
/**
 * For IE 11. Core-js doesn't seem to have one.
 */
if (!('prepend' in Element.prototype)) {
    Element.prototype.prepend = function () {
        var self = this
        arguments.length && Array.prototype.slice.call(arguments).forEach(function (n) {
            self.insertBefore(n, self.childNodes[0])
        })
    }
}
